<div class="main-container">
  <div class="main-page">
    <div class="prospect-detail">
      <div class="d-grid grid-prospect gap-32">
        @if(contrato?.numero_contrato) {
        <div>
          <div class="prospect-card">
            <div class="d-grid prospect-title">
              <div><h4 class="color-gray t-20">Contrato</h4></div>

              <div class="d-grid card-buttons-1 align-self-end">
                <div class="menu-container">
                  <div class="btn-group">
                    <button
                      class="action-btn primary d-flex align-items-center"
                      style="height: 38px; border-radius: 16px"
                    >
                      Activar
                    </button>

                    <div
                      class="dropdown-container"
                      (click)="$event.stopPropagation()"
                    >
                      <button
                        (click)="toggleActionsMenu('menu-' + contrato.contrato_id)"
                        class="btn btn-round-outline"
                      >
                        <img src="assets/svg/tridots.svg" class="center-svg" />
                      </button>
                      <div
                        class="dropdown-menu"
                        [class.show]="openedMenuId === 'menu-' + contrato.contrato_id"
                      >
                        <button
                        *ngIf="permissionService.hasPermission('Contratos','Editar')"
                          class="dropdown-item"
                          (click)="openmdlupdateContract(contrato)"
                        >
                          Modificar
                        </button>
                        <button
                        *ngIf="permissionService.hasPermission('Contratos','Eliminar')"
                          class="dropdown-item"
                          (click)="openmdldeleteContract(contrato.contrato_id)"
                        >
                          Eliminar
                        </button>
                        <button class="dropdown-item">Descargar</button>
                        <button
                          class="dropdown-item"
                          (click)="openMdlCreateContact()"
                        >
                          Nuevo contacto
                        </button>
                        <button
                        *ngIf="permissionService.hasPermission('Prospectos','Crear')"
                          class="dropdown-item"
                          (click)="openMdlCreateProspect()"
                        >
                          Nuevo prospecto
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-grid prospect-name mt-2">
              <div><img src="assets/svg/contract-icon.svg" alt="" /></div>
              <div>
                <h2 class="text-semibold">{{ contrato.numero_contrato }}</h2>
              </div>
            </div>

            <div class="d-flex flex-row gap-20 mt-1">
              <div class="text-tag color-org text-center">
                <b>Última actualización:</b>
                {{ contrato.fecha_actualizacion | date: 'dd/MM/yyyy' }}
              </div>
            </div>

            <div class="d-grid card-buttons-2 mt-2">
              <div class="text-center event-item">
                <button class="btn btn-round-outline" (click)="openNewCall()">
                  <img class="center-svg" src="assets/svg/call-icon.svg" />
                </button>
                <h5>Llamada</h5>
              </div>
              <div class="text-center event-item">
                <button class="btn btn-round-outline" (click)="openNewTask()">
                  <img class="center-svg" src="assets/svg/task-icon.svg" />
                </button>
                <h5>Tarea</h5>
              </div>
              <div class="text-center event-item">
                <button class="btn btn-round-outline" (click)="openNewEvent()">
                  <img class="center-svg" src="assets/svg/event-icon.svg" />
                </button>
                <h5>Evento</h5>
              </div>
              <div class="text-center event-item">
                <button class="btn btn-round-outline" (click)="openSendMail()">
                  <img class="center-svg" src="assets/svg/mail-icon.svg" />
                </button>
                <h5>Correo</h5>
              </div>
            </div>

            <div class="info-card mt-3">
              <div class="d-grid info-card-title">
                <h3>Información del contrato</h3>
                <div class="d-grid card-buttons-1">
                  <div *ngIf="!editInfo">
                    <img 
                    src="assets/svg/edit.svg" 
                    alt="Editar"
                    class="icon-clickable"
                    (click)="toggleEdit('info')"
                    />
                  </div>
                  <div *ngIf="editInfo" class="d-flex gap-10">
                    <button class="btn btn-primary" (click)="saveSection('info')">
                      Guardar
                    </button>
                    <button class="btn btn-outline" (click)="cancelEdit('info')">
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
              <div class="info-card-detail" >
                <table class="info-table">
                  <tbody>
                    <tr>
                      <td>Orden de compra:</td>
                      <td>
                        <ng-container *ngIf="!editInfo; else editOrdenCompra">
                          {{ contrato.orden_compra }}
                        </ng-container>
                        <ng-template #editOrdenCompra>
                          <input
                            class="crm-input"
                            type="text"
                            [(ngModel)]="editableContrato.orden_compra"
                          />
                        </ng-template>
                      </td>
                    </tr>
                    <tr>
                      <td>Fecha de inicio:</td>
                      <td>
                        <ng-container *ngIf="!editInfo; else editFechaInicio">
                          {{ contrato.fecha_inicio | date: 'dd/MM/yyyy' }}
                        </ng-container>
                        <ng-template #editFechaInicio>
                          <input
                            class="crm-input"
                            type="date"
                            [(ngModel)]="editableContrato.fecha_inicio"
                          />
                        </ng-template>
                      </td>
                    </tr>
                    <tr>
                      <td>Fecha de expiración:</td>
                      <td>
                        <ng-container *ngIf="!editInfo; else editFechaExpiracion">
                          {{ contrato.fecha_expiracion | date: 'dd/MM/yyyy' }}
                        </ng-container>
                        <ng-template #editFechaExpiracion>
                          <input
                            class="crm-input"
                            type="date"
                            [(ngModel)]="editableContrato.fecha_expiracion"
                          />
                        </ng-template>
                      </td>
                    </tr>
                    <tr>
                      <td>Duración del contrato:</td>
                      <td>
                        <ng-container *ngIf="!editInfo; else editDuracion">
                          {{ contrato.duracion_meses }} mes/es
                        </ng-container>
                        <ng-template #editDuracion>
                          <input
                            class="crm-input"
                            type="number"
                            [(ngModel)]="editableContrato.duracion_meses"
                          />
                        </ng-template>
                      </td>
                    </tr>
                    <tr>
                      <td>Nombre de la oportunidad:</td>
                      <td><span class="color-org">{{ contrato.oportunidades?.nombre }}</span></td>
                    </tr>
                    <tr>
                      <td>Nombre de la cuenta:</td>
                      <td><span class="color-org">
                        {{ contrato.oportunidades?.cuenta?.nombre_empresa }}
                      </span>
                      </td>
                    </tr>
                    <tr>
                      <td>Tipo de contrato:</td>
                      <td>
                        <ng-container *ngIf="!editInfo; else editTipo">
                          {{ contrato.tipo }}
                        </ng-container>
                        <ng-template #editTipo>
                          <select
                            class="crm-input"
                            [(ngModel)]="editableContrato.tipo"
                          >
                            <option value="Servicio">Servicio</option>
                            <option value="Suscripción de software">Suscripción de software</option>
                            <option value="Soporte">Soporte</option>
                            <option value="Arriendo de equipamiento hardware">Arriendo de equipamiento hardware</option>
                            <option value="Arriendo de software">Arriendo de software</option>
                            <option value="Arriendo de equipamiento ">Arriendo de equipamiento </option>
                            <option value="Consultoría">Consultoría</option>
                          </select>
                        </ng-template>
                      </td>
                    </tr>
                    <tr>
                      <td>Aviso de vencimiento:</td>
                      <td>
                        <ng-container *ngIf="!editInfo; else editRecordatorio">
                          {{ contrato.recordatorio_valor }} {{
                        contrato.recordatorio_unidad }} antes
                        </ng-container>
                        <ng-template #editRecordatorio>
                          <select
                            class="crm-input"
                            [(ngModel)]="selectedRecordatorio"
                            (change)="onRecordatorioChange()"
                            required

                          >
                            <option value="" disabled selected hidden>Selecciona aviso de vencimiento</option>
                            <option [ngValue]="null">Selecciona aviso de vencimiento</option>
                            <option [ngValue]="{ valor: 7, unidad: 'dias' }">7 días antes</option>
                            <option [ngValue]="{ valor: 15, unidad: 'dias' }">15 días antes</option>
                            <option [ngValue]="{ valor: 30, unidad: 'dias' }">30 días antes</option>
                            <option [ngValue]="{ valor: 2, unidad: 'meses' }">2 meses antes</option>
                            <option [ngValue]="{ valor: 3, unidad: 'meses' }">3 meses antes</option>
                            <option [ngValue]="{ valor: 6, unidad: 'meses' }">6 meses antes</option>
                            <option [ngValue]="{ valor: 12, unidad: 'meses' }">12 meses antes</option>
                          </select>
                        </ng-template>
                      </td>
                    </tr>
                    <tr>
                      <td>Monto acordado:</td>
                      <td>
                        <ng-container *ngIf="!editInfo; else editMonto">
                          {{ contrato.moneda }} {{ contrato.monto }}

                        </ng-container>
                        <ng-template #editMonto>
                          <input
                            class="crm-input"
                            type="number"
                            [(ngModel)]="editableContrato.monto"
                          />
                          <select
                            class="crm-input"
                            [(ngModel)]="editableContrato.moneda"
                          >
                            <option value="USD">USD</option>
                            <option value="CLP">CLP</option>
                          </select>
                        </ng-template>
                      </td>
                    </tr>
                    <tr>
                      <td>Observaciones:</td>
                      <td>
                        <ng-container *ngIf="!editInfo; else editObservaciones">
                          {{ contrato.observaciones || '—' }}
                        </ng-container>
                        <ng-template #editObservaciones>
                          <textarea
                            class="crm-input"
                            [(ngModel)]="editableContrato.observaciones"
                            rows="3"
                            style="height: 98px; resize: none"
                          ></textarea>
                        </ng-template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="info-card mt-4">
              <div class="d-grid info-card-title">
                <h3>Historial de registro</h3>
              </div>
              <div class="info-card-detail">
                <table class="info-table">
                  <tbody>
                    <tr>
                      <td>Creado por:</td>
                      <td><span class="color-org">
                        {{ contrato.creadoPor?.nombre }} {{
                        contrato.creadoPor?.apellido }}
                      </span>
                        
                      </td>
                      <td>
                        {{ contrato.fecha_creacion | date: 'dd/MM/yyyy' }}
                      </td>
                    </tr>
                    <tr>
                      <td>Modificado por:</td>
                      <td><span class="color-org">
                         {{ contrato.actualizadoPor?.nombre }} {{
                        contrato.actualizadoPor?.apellido }}
                      </span>
                       
                      </td>
                      <td>
                        {{ contrato.fecha_actualizacion | date: 'dd/MM/yyyy' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="prospect-info">
          <div class="main-open-tab" style="margin-bottom: 20px">
            <div class="open-tab-title">
              <div class="d-grid tab-title-detail">
                <div><h3 class="text-semibold">Estado contrato</h3></div>
                <button
                  class="action-btn primary d-flex align-items-center"
                  style="width: 271px; height: 38px; border-radius: 16px"
                >
                  <img
                    src="assets/svg/check-icon.svg"
                    width="20"
                    class="me-2"
                  />
                  Marcar como completado
                </button>
              </div>

              <div class="d-flex progress-status mt-3 flex-wrap gap-2">
                <div
                  class="status-card-1"
                  [ngClass]="{'status-inactive': contrato.estado !== 'Borrador'}"
                >
                  <div class="content-card-1 color-org"><b>Borrador</b></div>
                </div>
                <div
                  class="status-card-2"
                  [ngClass]="{'status-inactive': contrato.estado !== 'En proceso de aprobación'}"
                >
                  <div class="content-card-2">
                    <b>En proceso de aprobación</b>
                  </div>
                </div>
                <div
                  class="status-card-3"
                  [ngClass]="{'status-inactive': contrato.estado !== 'Activado'}"
                >
                  <div class="content-card-3"><b>Activado</b></div>
                </div>
              </div>
            </div>
          </div>
          <div class="detail-container white-bg" style="margin-top: 20px">
            <div class="contacts-container mt-4">
              <div class="d-grid contacts-header">
                <div class="d-flex align-items-center contact-title-wrapper">
                  <img
                    src="assets/svg/contract-icon.svg"
                    width="20"
                    class="contact-section-icon"
                  />
                  <h3 class="text-semibold contact-title">
                    Historial de contratos (2)
                  </h3>
                </div>
                >
              </div>

              <div class="prospectos-table mt-3">
                <table class="stage-history-table">
                  <thead>
                    <tr>
                      <th>
                        <div class="th-content">
                          <span>Fecha</span>
                          <img
                            src="assets/svg/arrow-down-black.svg"
                            class="sort-icon"
                          />
                        </div>
                      </th>
                      <th>
                        <div class="th-content">
                          <span>Cambio Realizado</span>
                          <img
                            src="assets/svg/arrow-down-black.svg"
                            class="sort-icon"
                          />
                        </div>
                      </th>
                      <th>
                        <div class="th-content">
                          <span>Usuario</span>
                          <img
                            src="assets/svg/arrow-down-black.svg"
                            class="sort-icon"
                          />
                        </div>
                      </th>
                      <th>
                        <div class="th-content">
                          <span>Valor anterior</span>
                          <img
                            src="assets/svg/arrow-down-black.svg"
                            class="sort-icon"
                          />
                        </div>
                      </th>
                      <th>
                        <div class="th-content">
                          <span>Valor actualizado</span>
                          <img
                            src="assets/svg/arrow-down-black.svg"
                            class="sort-icon"
                          />
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>29/09/2025 18:45</td>
                      <td>Estado</td>
                      <td>Juan Soto</td>
                      <td>Borrador</td>
                      <td>En proceso de aprobación</td>
                    </tr>
                    <tr>
                      <td>29/09/2025 16:20</td>
                      <td>Creado</td>
                      <td>Juan Soto</td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr class="view-all-row">
                      <td colspan="6" class="text-center">
                        <button
                          class="btn btn-link color-org"
                          style="
                            width: 125px;
                            height: 32px;
                            border-radius: 32px;
                            border: 1px solid;
                            background-color: white;
                          "
                        >
                          Ver todos
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="contacts-container mt-4">
              <div class="d-grid contacts-header">
                <div class="d-flex align-items-center contact-title-wrapper">
                  <img
                    src="assets/svg/folder-icon.svg"
                    width="20"
                    class="contact-section-icon"
                  />
                  <h3 class="text-semibold contact-title">Archivos (0)</h3>
                </div>
                <div class="justify-self-end">
                  <button class="action-btn primary d-flex align-items-center">
                    <img
                      src="assets/svg/upload-arrow-icon.svg"
                      width="20"
                      class="me-2"
                    />
                    Subir archivos
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        } @else {
        <div class="no-contact-message">
          <p>No se encontró información del contrato</p>
        </div>
        }
      </div>
    </div>
  </div>
</div>
